import Vue from 'vue';

const arrayifyControls = controls => {
  let arr = [];
  for (const key in controls) {
    if (controls.hasOwnProperty(key)) {
      const controlOrGroup = controls[key];

      if (controlOrGroup instanceof Vue) {
        arr.push(controlOrGroup);
      } else {
        arr = arr.concat(arrayifyControls(controlOrGroup))
      }
    }
  }

  return arr;
}

export default arrayifyControls;
